export default __webpack_public_path__ + "static/media/snow_night.c969a949.svg";